const WELCOME_MESSAGE_PLACEHOLDER = {
  COACH_NAME: 'coachName',
  USER_NAME: 'userName',
};

const MEAL_PLAN_INTRODUCTION_PLACEHOLDER = {
  CLIENT_NAME: 'clientName',
};

const BIRTHDAY_MESSAGE_PLACEHOLDER = {
  CLIENT_NAME: 'clientName',
  COACH_NAME: 'coachName',
  AGE: 'age',
};

export {
  BIRTHDAY_MESSAGE_PLACEHOLDER,
  MEAL_PLAN_INTRODUCTION_PLACEHOLDER,
  WELCOME_MESSAGE_PLACEHOLDER,
};
